import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  return (
    <nav>
      <Link to="/">
        <h1>Shay Apparel</h1>
      </Link>
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/women">Women</Link>
        <Link to="/kids">Kids</Link>
        {localStorage.getItem("isAdmin") && <Link to="/admin">Admin</Link>}
        {localStorage.getItem("isAdmin") && (
          <button
            className="logout-btn"
            onClick={() => {
              localStorage.removeItem("isAdmin");
              navigate("/login");
            }}
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
